<template>
    <SettingsTemplate :isCustomMenu="true" backUrl="/settings/home/internal" :menuItems="menu" />
</template>

<script>
import Feature from 'Services/Feature';
import SettingsTemplate from 'vcomponents/settings/SettingsTemplate.vue';
import generateHash from '../../../helpers/hashGenerator';

export default {
    components: {
        SettingsTemplate,
    },
    data() {
        return {
            menu: {
                label: this.$l10n.__('Marketing'),
                sub: [],
            },
        };
    },
    created() {
        if (Feature.isEnabled('sendethic')) {
            this.menu.sub.push({
                label: this.$l10n.__('Synchronisation des champs'),
                route: { name: 'marketing.preferences.attributes' },
                id: generateHash(),
            });
        }

        if (Feature.isEnabled('rgpd-consent-v202312')) {
            this.menu.sub.push({
                label: this.$l10n.__('Inscriptions aux campagnes'),
                route: { name: 'marketing.preferences.consent' },
                id: generateHash(),
            });
        }
    },
};
</script>
